import { render, staticRenderFns } from "./approvalNotification.vue?vue&type=template&id=3d950732&scoped=true"
import script from "./approvalNotification.vue?vue&type=script&lang=js"
export * from "./approvalNotification.vue?vue&type=script&lang=js"
import style0 from "./approvalNotification.vue?vue&type=style&index=0&id=3d950732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d950732",
  null
  
)

export default component.exports